import { it } from "./catalogs/it.js";
import { en } from "./catalogs/en.js";
export const locales = ["it", "en"];
export class MissingTranslationError extends Error {
    locale;
    key;
    constructor(locale, key) {
        super(`Missing translation for "${key}" in locale "${locale}"`);
        this.name = "MissingTranslationError";
        this.locale = locale;
        this.key = key;
    }
}
const catalogs = { it, en };
function lookup(catalog, key) {
    // Catalog è CatalogShape<typeof it> (vedi shape.ts): chiavi dell'italiano, foglie string.
    let node = catalog;
    for (const part of key.split(".")) {
        if (typeof node !== "object" || node === null || !(part in node))
            return undefined;
        node = node[part];
    }
    return typeof node === "string" ? node : undefined;
}
export function createTranslator(locale) {
    const catalog = catalogs[locale];
    return (key, params = {}) => {
        const template = lookup(catalog, key);
        if (template === undefined)
            throw new MissingTranslationError(locale, key);
        return template.replace(/\{(\w+)\}/g, (match, name) => name in params ? String(params[name]) : match);
    };
}
/**
 * Le chiavi dei messaggi sotto un gruppo del catalogo (per esempio `leadCard.fields`), nell'ordine del catalogo
 * italiano; i due cataloghi hanno le stesse chiavi. Un gruppo che non esiste non ha chiavi.
 */
export function messageKeysUnder(group) {
    let node = catalogs.it;
    for (const part of group.split(".")) {
        if (typeof node !== "object" || node === null || !Object.hasOwn(node, part))
            return [];
        node = node[part];
    }
    const keys = [];
    const visit = (value, prefix) => {
        if (typeof value === "string")
            keys.push(prefix);
        else if (typeof value === "object" && value !== null)
            for (const [key, child] of Object.entries(value))
                visit(child, `${prefix}.${key}`);
    };
    if (typeof node !== "object")
        return [];
    visit(node, group);
    return keys;
}
//# sourceMappingURL=translator.js.map